(function () {
  'use strict';

  // Closing band of the comic PDP: START NOW scrolls to the purchase box, ADD TO CART submits the main buy form
  // with whatever the shopper has selected (tins and Subscribe & save), through the same handler as the main button.
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-scs-start]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      if (target.id === 'boost-buying-options') {
        target.querySelector('[data-quantity-option]:checked')?.focus({ preventScroll: true });
      }
      target.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
    });
  });

  document.querySelectorAll('[data-scs-add]').forEach((button) => {
    button.addEventListener('click', () => {
      const form = document.querySelector('form[data-sp-form]');
      if (!form) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.querySelector('[data-add-button]')?.click();
    });
  });
})();
